import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';
import {
  Heading,
  Text,
  UnorderedList,
  Link,
  Image,
  OrderedList,
} from '@chakra-ui/react';

const ChakraMarkdown = ({ content, pColor = '#0b0b0b', onLinkClick }) => {
  return (
    <ReactMarkdown
      children={content}
      remarkPlugins={[remarkBreaks, remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        h1: ({ node, ...props }) => (
          <Heading as="h1" size="4xl" noOfLines={1} {...props} />
        ),
        h2: ({ node, ...props }) => (
          <Heading as="h2" size="1xl" noOfLines={1} {...props} />
        ),
        h3: ({ node, ...props }) => (
          <Heading as="h3" size="xl" noOfLines={1} {...props} />
        ),
        h4: ({ node, ...props }) => (
          <Heading as="h4" size="lg" noOfLines={1} {...props} />
        ),
        h5: ({ node, ...props }) => (
          <Heading as="h5" size="md" noOfLines={1} {...props} />
        ),
        h6: ({ node, ...props }) => (
          <h6
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
            {...props}
          />
        ),
        iframe: ({ node, ...props }) => (
          <iframe style={{ alignSelf: 'center' }} {...props} />
        ),
        p: ({ node, ...props }) => (
          <Text color={pColor} fontSize={14} my={2} {...props} />
        ),
        ul: ({ node, ...props }) => (
          <UnorderedList my={4} {...props} pl={'0px'} role="list" />
        ),
        ol: ({ node, ...props }) => (
          <OrderedList {...props} role="list"></OrderedList>
        ),
        li: ({ node, ...props }) => <li {...props} style={{ fontSize: 14 }} />,
        a: ({ node, ...props }) => (
          <Link color={'#11a00d'} {...props} onClick={onLinkClick} />
        ),
        img: ({ node, ...props }) => <Image src={props.src} alt="img" />,
        em: ({ node, ...props }) => (
          <em style={{ color: '#0b0b0b' }} {...props} />
        ),
      }}
    />
  );
};

export default ChakraMarkdown;
